import { PureComponent } from 'react';

class ErrorBoundary extends PureComponent {
    state = {
        errorMessage: ''
    };

    static getDerivedStateFromError(error) {
        return { errorMessage: error.toString() };
    }

    componentDidCatch(error, info) {
        const errorString = error.toString();
        console.error(errorString, info);
        try {
            // eslint-disable-next-line no-undef
            newrelic?.noticeError?.(errorString);
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        if (this.state.errorMessage) {
            return (
                <h1 style={{ 'textAlign': 'center', 'margin': '10rem' }}>
                    The Help & Support is currently unavailable
                </h1>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
